import React, { useEffect } from "react";
import Button from "@mui/joy/Button";
import UploadFilesComp from "./UploadFilesComp";
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
import useQuotationRequestById from "../../../../../../../store/ReactQueries/procurements/quotationRequests/useQuotationRequestById";
import { Modal } from '@mui/base/Modal';
import { ModeTypes } from "../AddPurchaseOrder";
import { StyledBackdrop } from "../../../../../Users/NewAccModal";
import { darkModeBackgroudInputs } from "../../../../../../../utils/constants";
import { useDarkModeStore } from "../../../../../../../store/useDarkModeStore";
import { useLanguageStore } from "../../../../../../../store/useLanguageStore";
import { ModalContent } from "../../../../../../../common/TopBar/Buttons/SearchTopBarModal";
import { QuotationRequestInterface } from "../../../../../../../models/ProcurementModule/QuotationRequest";

interface AddFilesModalProps {
    open: {
        id: string;
        value: boolean;
    }
    hasApprovedOffer: boolean;
    purchaseOrderId: string | undefined;
    quotationForm: QuotationRequestInterface;
    onClose: () => void;
    setQuotationForm: React.Dispatch<React.SetStateAction<QuotationRequestInterface>>;
}

const FilesModal: React.FC<AddFilesModalProps> = ({
    open, quotationForm, purchaseOrderId, hasApprovedOffer,
    setQuotationForm, onClose

}) => {
    const { darkMode } = useDarkModeStore();
    const { language } = useLanguageStore();
    const { data: getQuotionRequestById, refetch } = useQuotationRequestById(open.id);

    const modalTitle = `${language['DocumentsForVendor']} ${getQuotionRequestById?.vendor?.name ?? ''}`;

    useEffect(() => {
        refetch();
    }, [open.id]);

    return (
        <Modal
            open={open.value}
            onClose={onClose}
            slots={{ backdrop: StyledBackdrop }}
        >
            <ModalContent
                sx={{
                    width: hasApprovedOffer ? 400 : 850,
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: darkMode ? darkModeBackgroudInputs : 'white',
                    zIndex: 1300,
                }}
            >
                <div className="d-flex flex-row align-items-center ps-3 pe-3 pt-3">
                    <h4
                        className={`${darkMode ? 'text-white' : 'text-muted'} text-truncate`}
                        style={{ maxWidth: 800 }}
                        title={modalTitle}
                    >
                        {modalTitle}
                    </h4>
                    <IconButton
                        aria-label="Close Modal"
                        title="Close Modal"
                        size="small"
                        color="default"
                        className="ms-auto"
                        onClick={onClose}
                    >
                        <ClearIcon />
                    </IconButton>
                </div>
                <hr className={`m-0 mt-2 p-0 ${darkMode && 'text-white opacity-100'}`} />
                <UploadFilesComp
                    mode="Show"
                    purchaseOrderId={purchaseOrderId}
                    open={open}
                    form={quotationForm}
                    setForm={setQuotationForm}
                    fileNames={[]}
                    setFileNames={function (value: React.SetStateAction<{ fileUrl: string; fileName: string; }[]>): void {
                        throw new Error("Function not implemented.");
                    }}
                />

                <hr className={`m-0 mt-2 p-0 ${darkMode && 'text-white opacity-100'}`} />

                <div className="d-flex align-items-center justify-content-end p-2 mt-2">
                    <Button
                        className="w-25"
                        sx={{
                            background: darkMode ? darkModeBackgroudInputs : "white",
                            border: `1px solid var(--btn-color)`,
                            color: darkMode ? 'white' : "var(--btn-color)",
                            fontWeight: 700,
                            "&:hover": {
                                background: darkMode ? darkModeBackgroudInputs : "white",
                                opacity: .7,
                            },
                        }}
                        onClick={onClose}
                    >
                        {language["Cancel"]}
                    </Button>
                </div>
            </ModalContent>
        </Modal>
    );
};

export default FilesModal;
